/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Destination_LabelInputs */



/**
* | output |
* | --- |
* | "Backup Destination" |
*
* @param {Options_Backup_Destination_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_destination_label = /** @type {((inputs?: Options_Backup_Destination_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Destination_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Destination de sauvegarde")
	if (locale === "de") return /** @type {LocalizedString} */ ("Backup-Ziel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Destinazione di backup")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Место назначения резервной копии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Destino de la copia de seguridad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("备份目标")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バックアップ先")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैकअप गंतव्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Destino de backup")
	return /** @type {LocalizedString} */ ("Backup Destination")
});